import React, {useEffect, useState} from 'react';
import {Link, Redirect} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Header from './Header';
import {Fab, IconButton, LinearProgress, Typography} from "@material-ui/core";
import StyledTextField from "./StyledTextField";
import StyledButton from "./StyledButton";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {useDispatch, useSelector} from "react-redux";
import { useClipboard } from 'use-clipboard-copy';
import Tooltip from '@material-ui/core/Tooltip';
import ErrorIcon from '@material-ui/icons/Error';

import * as Actions from "../../redux/actions";
import {isRTL} from "../../utils";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: 'rgba(247, 247, 249, 0.5)',
    },
    main: {
        background: '#FFFFFF',
        borderRadius: '2px',
        width: '310px',
        display: 'flex',
        margin: '0 auto 10px',
        alignItems: 'center',
        flexDirection: 'column'
    },
    button: {
        width: '144px',
        margin: '4px'
    },
    list: {
        width: '100%'
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        height: '32px',
        '&:hover' : {
            backgroundColor: 'rgba(36, 232, 255, 0.04)',
            cursor: 'pointer'
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(18, 116, 228, 0.05)'
        },
        '& > p': {
            flexGrow: 1,
            fontSize: '14px',
            fontFamily: 'Assistant'
        }
    },
    description: {
        padding: '12px',
        fontFamily: 'Assistant',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        letterSpacing: '0.2px',
        color: '#595959',
        marginBottom: '10px'
    },
    progress: {
        marginTop :'12px',
        width: '74%'
    },
    deleteButton: {
        width: '11px',
        height: '11px',
    },
    deleteIcon: {
        width: '11px',
        height: '11px',
    },
    link: {
        padding: '0 20px',
        lineHeight: '33px',
        background: '#1174E5',
        textAlign: 'center',
        display: 'flex',
        margin: '0 4px',
        textDecoration: 'none',
        alignItems: 'center',
        flexDirection: 'row'
    },
    span: {
        color: '#fff',
        paddingLeft: '8px',
        fontWeight: '700',
        fontSize:' 10px',
        fontFamily: 'Nunito',
    },
    textArea: {
        width: '294px',
        fontSize: '12px',
        lineHeight: '15px',
        padding: '15px',
        boxSizing: 'border-box',
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid #F7F7F9',
        borderRadius: '2px',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        '&::placeholder': {
            color: '#030229',
            opacity: '1',
        },
    },
    textAreaResult: {
        width: '294px',
        padding: '15px',
        boxSizing: 'border-box',
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid #F7F7F9',
        borderRadius: '2px',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        margin: '5px 0',
    },
    titleKeep: {
        color: '#1174E5',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
    },
    colorOne: {
        color: '#9411AC',
    },
    colorSecond: {
        color: '#00B298',
    },
    bgOne: {
        border: 'none',
        background: 'rgba(148, 17, 172, 0.15)',
        borderRadius: '2px',
    },
    bgSecond: {
        border: 'none',
        background: 'rgba(0, 178, 152, 0.15)',
        borderRadius: '2px',
    },
    titleBack: {
        color: '#9411AC',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
        textDecoration: 'none',
        marginLeft: '10px',
        cursor: "pointer",
    },
    titleBack2: {
        color: '#9411AC',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
        textDecoration: 'none',
        marginLeft: '5px',
    },
    noBg: {
        background: 'none',
        minWidth: 'auto',
        '&:hover': {
            background: 'none',
        },
    },
    styleBlock: {
        display: 'flex',
        paddingLeft: '20px',
        width: '100%',
        boxSizing: 'border-box',
        justifyContent: 'left',
        '& p': {
            color: 'rgba(148, 17, 172, 0.8)',
            fontWeight: '700',
            margin: '6px 0',
            fontSize:' 10px',
            fontFamily: 'Nunito',
            cursor: 'pointer',
            '& span span': {
                paddingLeft: '8px',
                color: 'rgba(148, 17, 172, 0.8)',
                fill:  'rgba(148, 17, 172, 0.8)',
            }
        },
        '&:hover span, &:hover span svg path': {
            color: '#9411AC',
            fill:  '#9411AC',
        }
    },
    title: {
        color: '#030229',
        fontFamily: 'Nunito',
        fontSize: '10px',
        fontWeight: '800',
        fontStyle: 'normal',
    },
    styleForBlockSuggest: {
        display: 'flex',
        marginTop: '20px',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        paddingLeft: '10px',
        boxSizing: 'border-box',
    },
    textField: {
        marginLeft: '40px',
        '& :before' : {
            display: 'none',
        },
        '& input' : {
            background: '#FBFBFC',
            border: '1px solid #F7F7F9',
            borderRadius: '2px',
            padding: '4px 5px',
            '& :before' : {
                display: 'none',
            },
        },
        '& input::placeholder': {
            color: '#030229',
            opacity: '1',
        },
    },
    empty: {
        '& input' : {
            border: '1px solid #FF7070',
        }
    },
    aiError: {
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 89, 89, 0.1)',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.03)',
        borderRadius: '4px',
        width: '294px',
        boxSizing: 'border-box',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        marginTop: '20px',
    },
    titleAiError: {
        color: '#FF5959',
        background: 'rgba(255, 89, 89, 0.15)',
        borderRadius: '4.2px 4.2px 1px 1px;',
        height: '22px',
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '10px',
        lineHeight: '14px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    aiErrorContent: {
        padding: '30px 20px 20px 20px',
    },
    aiErrorIcon: {
        display: 'flex',
        width: '100%',
        marginBottom: '15px',
    },
    aiErrorText : {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '11px',
        display: 'flex',
        alignItems: 'center',
        color: '#FF5959',
    },
    inputCheck: {
        marginLeft: '-20px',
        zIndex: '1',
        marginTop: '7px',
    },
    inputCheckError: {
        marginLeft: '-15px',
        zIndex: '1',
        marginTop: '9px',
    },
    error: {
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid rgba(255, 89, 89, 0.15)',
        borderRadius: '2px',

        '&::placeholder': {
            color: 'rgba(255, 89, 89, 0.5)',
        },
    },
    styleBlockForCheckbox: {
        display: 'flex',
        paddingLeft: '20px',
        width: '100%',
        boxSizing: 'border-box',
        justifyContent: 'left',
        marginBottom: '6px',
        '& span': {
            color: '#505050',
            fontWeight: '700',
            fontSize:' 10px',
            fontFamily: 'Nunito',
            cursor: 'pointer',
        },
    },


}));

export default function AskAi({}) {
    const classes = useStyles();
    const [edit, setEdit] = useState(true);
    const [emptyText, setEmptyText] = useState(undefined);
    const [emptyParty, setEmptyParty] = useState(undefined);
    const [party, setParty] = useState('');
    const [text, setText] = useState('');
    const [isLoading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const clipboard = useClipboard();
    const promptAi = useSelector(state => state.document.promptAi)
    const promptAiResult = useSelector(state => state.document.promptAiResult)
    const promptAiAction = useSelector(state => state.document.promptAiAction)
    const promptAiError = useSelector(state => state.document.promptAiError)
    const contextData = useSelector(state => state.document.contextData)
    const promptAiErrorText = useSelector(state => state.document.promptAiErrorText)
    const [prompt, setPrompt] = useState(promptAi);
    const [result, setResult] = useState(promptAiResult);
    const [emptyPrompt, setEmptyPrompt] = useState(undefined);
    const [checked, setChecked] = useState(false);
    const [redirectPage, setRedirectPage] = useState(undefined);

    const RTL = isRTL(prompt);

    const handleEdditAskAiClick = async () => {
        setEdit(false)
    };
    const handleDoneAskAiClick = async () => {
        setEdit(true)
        setChecked(false)
    };

    useEffect( () => {
        setResult(promptAiResult)
    }, [promptAiResult] );

    const handleClick = () => {
        clipboard.copy(result);
    }

    const handleAskAiClick = async () => {
        if(prompt && prompt.length > 0){
            setEmptyPrompt(false);
            await setLoading(true);
            await dispatch(Actions.askAi( prompt, promptAiAction, 'alternative', contextData ));
            await setLoading(false);
        } else {
            setEmptyPrompt(true);
        }
    };

    const handleChange = async (event) => {
        setChecked(true);
        setEmptyPrompt(false)
        setEmptyText(false)
        await setLoading(true);
        await dispatch(Actions.askAi( prompt, 'custom', 'alternative', contextData ));
        await setLoading(false);
    };

    const handleAskAiClickWithAction = async (action) => {
        switch (action) {
            case 'custom':
                if(text.length > 0 && prompt && prompt.length > 0){
                    setEmptyPrompt(false)
                    setEmptyText(false)
                    await setLoading(true);
                    await dispatch(Actions.askAi( prompt, action, text, contextData ));
                    await setLoading(false);
                } else {
                    setEmptyText(true)
                }
                if ( !prompt && prompt.length === 0){
                    setEmptyPrompt(true);
                }
                break;
            case 'proOneParty':
                if(party.length > 0 && prompt && prompt.length > 0){
                    setEmptyPrompt(false)
                    setEmptyParty(false)
                    await setLoading(true);
                    await dispatch(Actions.askAi( prompt, action, party, contextData ));
                    await setLoading(false);
                } else {
                    setEmptyParty(true)
                }
                if ( !party && party.length === 0){
                    setEmptyPrompt(true);
                }
                break;
            default:
                if(prompt && prompt.length > 0){
                    setEmptyPrompt(false)
                    await setLoading(true);
                    await dispatch(Actions.askAi( prompt, action, 'alternative', contextData ));
                    await setLoading(false);
                } else {
                    setEmptyPrompt(true);
                }

        }
    };

    const handleBack = async () => {
        setRedirectPage(`/`)
    };


    return  redirectPage ? <Redirect to={redirectPage} /> : (
        <div className={classes.root}>
            <Header showButton={false} />
            <div className={classes.main}>
                <div style={{display: 'flex', marginBottom: '12px', justifyContent: 'space-between', width: '100%', alignItems: 'center', marginTop: '10px',}}>
                    <span className={classes.titleBack} onClick={handleBack}>
                        <svg className={classes.svg} width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5C9.27614 5 9.5 4.77614 9.5 4.5C9.5 4.22386 9.27614 4 9 4V5ZM0.646446 4.14645C0.451184 4.34171 0.451184 4.65829 0.646446 4.85355L3.82843 8.03553C4.02369 8.2308 4.34027 8.2308 4.53553 8.03553C4.7308 7.84027 4.7308 7.52369 4.53553 7.32843L1.70711 4.5L4.53553 1.67157C4.7308 1.47631 4.7308 1.15973 4.53553 0.964466C4.34027 0.769204 4.02369 0.769204 3.82843 0.964466L0.646446 4.14645ZM9 4L1 4V5L9 5V4Z" fill="#9411AC"/>
                        </svg>
                        <span className={classes.titleBack2}>Back</span>
                    </span>

                    <Typography className={classes.title}>Ask AI</Typography>

                    { edit ?
                        <StyledButton onClick={handleEdditAskAiClick} className={classes.noBg}>
                            <svg className={classes.svg} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.0808 3.10666C11.3083 2.87916 11.3083 2.49999 11.0808 2.28416L9.71583 0.91916C9.5 0.69166 9.12083 0.69166 8.89333 0.91916L7.82 1.98666L10.0075 4.17416M0.75 9.06249V11.25H2.9375L9.38917 4.79249L7.20167 2.60499L0.75 9.06249Z" fill="#1174E5"/>
                            </svg>
                        </StyledButton>
                        :
                        <StyledButton onClick={handleDoneAskAiClick} className={classes.button}>
                            Done
                        </StyledButton>
                    }

                </div>
                <div style={{display: 'flex'}}>

                    { RTL ? <div dir={"rtl"}>
                        <TextareaAutosize disabled={edit} minRows={15}  name='prompt' className={ emptyPrompt ? classes.textArea + ' ' + classes.error :  classes.textArea} value={prompt}
                                          onChange={(e)=> {setPrompt(e.target.value);}}
                        />
                    </div> :  <TextareaAutosize disabled={edit} minRows={15}  name='prompt' className={ emptyPrompt ? classes.textArea + ' ' + classes.error :  classes.textArea} value={prompt}
                                                onChange={(e)=> {setPrompt(e.target.value);}}
                    />}



                </div>


                <div className={classes.styleBlockForCheckbox}>
                    <FormControlLabel
                        control={<Checkbox checked={checked} disabled={checked} onChange={handleChange} name="checkedG" />}
                        label="Send the above message to AI (not related to a clause)"
                    />

                </div>


                <div style={{
                    display: 'flex',
                    paddingLeft: '20px',
                    width: '100%',
                    boxSizing: 'border-box',
                    justifyContent: 'left',
                    marginBottom: '8px',
                }}>
                    <Typography className={classes.title}>Rephrase the text above as following:</Typography>
                </div>


                <div className={classes.styleBlock}>
                    <p onClick={()=>{handleAskAiClickWithAction('makeMutual')}}>
                        <Tooltip title="rephrase the clause so it will show both parties interests" arrow placement="top">
                            <span>
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.999999 0C0.445 0 0 0.445 0 0.999999V5.49999C0 5.77614 0.223857 5.99999 0.5 5.99999C0.776142 5.99999 0.999999 5.77614 0.999999 5.49999V0.999999H5.49999C5.77614 0.999999 5.99999 0.776142 5.99999 0.5C5.99999 0.223857 5.77614 0 5.49999 0H0.999999ZM3 2C2.445 2 2 2.445 2 3V7.49999C2 7.77613 2.22386 7.99999 2.5 7.99999C2.77614 7.99999 3 7.77613 3 7.49999V3H7.49999C7.77613 3 7.99999 2.77614 7.99999 2.5C7.99999 2.22386 7.77613 2 7.49999 2H3ZM5 4C4.445 4 4 4.445 4 5V8.99999C4 9.55499 4.445 9.99999 5 9.99999H8.99999C9.55499 9.99999 9.99999 9.55499 9.99999 8.99999V5C9.99999 4.445 9.55499 4 8.99999 4H5Z" fill="#9411AC"/>
                                </svg>
                                <span>Make Mutual</span>
                            </span>
                        </Tooltip>
                    </p>
                </div>

                <div className={classes.styleBlock}>
                    <p onClick={()=>{handleAskAiClickWithAction('proOneParty')}}>
                        <Tooltip title="rephrase as pro owner / pro buyer / pro other party" arrow placement="top">
                            <span>
                                <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.5 3.99997C2.95 3.99997 2.5 3.54997 2.5 2.99997C2.5 2.44997 2.95 1.99997 3.5 1.99997C4.05 1.99997 4.5 2.44997 4.5 2.99997C4.5 3.54997 4.05 3.99997 3.5 3.99997ZM6.29999 1.99997C5.89999 0.849969 4.8 -3.05176e-05 3.5 -3.05176e-05C1.85 -3.05176e-05 0.5 1.34997 0.5 2.99997C0.5 4.64996 1.85 5.99996 3.5 5.99996C4.8 5.99996 5.89999 5.14996 6.29999 3.99997H7.99999V4.99997C7.99999 5.55225 8.44771 5.99996 8.99999 5.99996C9.55228 5.99996 9.99999 5.55225 9.99999 4.99996V3.99997H10.5C11.0523 3.99997 11.5 3.55225 11.5 2.99997C11.5 2.44768 11.0523 1.99997 10.5 1.99997H6.29999Z" fill="#9411AC"/>
                                </svg>
                                <span>Pro one party</span>
                            </span>
                        </Tooltip>
                    </p>
                    <StyledTextField type='text' placeholder='Type Party...' name='party' value={party} className={
                        emptyParty ? classes.textField + ' ' + classes.empty : classes.textField
                    }
                        onChange={(e)=> {setParty(e.target.value);}}
                        onKeyPress={(e) => {
                             if (e.key === 'Enter' && party && party.length > 3  ) {
                                 handleAskAiClickWithAction('proOneParty')
                             }
                         }}
                    >
                    </StyledTextField>
                    {party && party.length > 3 ? <svg onClick={()=>{handleAskAiClickWithAction('proOneParty')}} className={classes.inputCheck} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="13" height="13" rx="2" fill="#1174E5"/>
                        <path d="M10.625 4.20832L5.12502 9.70832L2.60419 7.18749L3.25044 6.54124L5.12502 8.41124L9.97877 3.56207L10.625 4.20832Z" fill="white"/>
                    </svg> : null }
                    {emptyParty ? <svg className={classes.inputCheckError} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.375 2.625H4.125V1.875H3.375M3.75 6.75C2.09625 6.75 0.75 5.40375 0.75 3.75C0.75 2.09625 2.09625 0.75 3.75 0.75C5.40375 0.75 6.75 2.09625 6.75 3.75C6.75 5.40375 5.40375 6.75 3.75 6.75ZM3.75 0C3.25754 0 2.76991 0.0969966 2.31494 0.285452C1.85997 0.473907 1.44657 0.75013 1.09835 1.09835C0.395088 1.80161 0 2.75544 0 3.75C0 4.74456 0.395088 5.69839 1.09835 6.40165C1.44657 6.74987 1.85997 7.02609 2.31494 7.21455C2.76991 7.403 3.25754 7.5 3.75 7.5C4.74456 7.5 5.69839 7.10491 6.40165 6.40165C7.10491 5.69839 7.5 4.74456 7.5 3.75C7.5 3.25754 7.403 2.76991 7.21455 2.31494C7.02609 1.85997 6.74987 1.44657 6.40165 1.09835C6.05343 0.75013 5.64003 0.473907 5.18506 0.285452C4.73009 0.0969966 4.24246 0 3.75 0ZM3.375 5.625H4.125V3.375H3.375V5.625Z" fill="#FF7070"/>
                    </svg> : null}
                </div>

                <div className={classes.styleBlock}>
                    <p onClick={()=>{handleAskAiClickWithAction('rewrite')}}>
                        <div >
                            <span>
                                <svg width="12" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.35499 2.52C9.18499 2.69 9.01999 2.855 9.01499 3.02C8.99999 3.18 9.16999 3.345 9.32999 3.5C9.56999 3.75 9.80499 3.975 9.79499 4.22C9.78499 4.46499 9.52999 4.71999 9.27499 4.96999L7.56457 6.68456C7.36881 6.88079 7.05098 6.88098 6.85499 6.68499C6.659 6.489 6.65918 6.17118 6.85541 5.97542L8.62499 4.21L8.14499 3.73L7.43499 4.43499L5.55999 2.56L7.47999 0.644999C7.67499 0.449999 7.99999 0.449999 8.18499 0.644999L9.35499 1.815C9.54999 2 9.54999 2.325 9.35499 2.52ZM0.5 7.62499L5.28 2.84L7.15499 4.71499L2.375 9.49999H0.5V7.62499Z" fill="#9411AC"/>
                                </svg>
                                <span>Rewrite</span>
                            </span>
                        </div>
                    </p>
                </div>

                <div className={classes.styleBlock}>
                    <p onClick={()=>{handleAskAiClickWithAction('explain')}}>
                        <div>
                            <span>
                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.5 1.5C5.03043 1.5 5.53914 1.71071 5.91421 2.08578C6.28928 2.46086 6.49999 2.96956 6.49999 3.5C6.49999 4.03043 6.28928 4.53914 5.91421 4.91421C5.53914 5.28928 5.03043 5.49999 4.5 5.49999C3.96956 5.49999 3.46086 5.28928 3.08578 4.91421C2.71071 4.53914 2.5 4.03043 2.5 3.5C2.5 2.96956 2.71071 2.46086 3.08578 2.08578C3.46086 1.71071 3.96956 1.5 4.5 1.5ZM4.5 6.49999C5.83499 6.49999 8.49999 7.16999 8.49999 8.49999V9.49999H0.5V8.49999C0.5 7.16999 3.165 6.49999 4.5 6.49999ZM7.91478 2.14798C8.1682 1.89305 8.59103 1.89885 8.77165 2.20965C9.25684 3.04453 9.25943 4.01399 8.77939 4.80753C8.59452 5.11314 8.17546 5.10924 7.92365 4.85593C7.70201 4.63298 7.68815 4.28496 7.78112 3.98465C7.88086 3.6625 7.8796 3.31996 7.77735 2.99832C7.68432 2.70565 7.69827 2.36578 7.91478 2.14798ZM9.61564 0.419355C9.84621 0.188779 10.2241 0.19006 10.4247 0.447159C11.8648 2.29303 11.8579 4.76558 10.4323 6.556C10.2273 6.81349 9.84647 6.81147 9.61373 6.57873C9.39203 6.35703 9.38406 6.00367 9.55839 5.74306C10.4888 4.35219 10.4922 2.5924 9.56862 1.25217C9.39111 0.994562 9.39442 0.640571 9.61564 0.419355Z" fill="#9411AC"/>
                                </svg>
                                <span>Explain in Plain Language</span>
                            </span>
                        </div>
                    </p>
                </div>

                <div className={classes.styleBlock}>
                    <p onClick={()=>{handleAskAiClickWithAction('summarize')}}>
                        <Tooltip title="Show a shortened / summarized version of the selected clause" arrow placement="top">
                            <span>
                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 5.99999C2.055 5.99999 2.5 5.55499 2.5 5C2.5 4.45 2.055 4 1.5 4C0.95 4 0.5 4.45 0.5 5C0.5 5.55499 0.95 5.99999 1.5 5.99999ZM2 0.5C2 0.223858 1.77614 0 1.5 0C1.22386 0 1 0.223857 1 0.499999V2.5C1 2.77614 1.22386 3 1.5 3C1.77614 3 2 2.77614 2 2.5V0.5ZM1 9.49999C1 9.77613 1.22386 9.99999 1.5 9.99999C1.77614 9.99999 2 9.77613 2 9.49999V7.49999C2 7.22385 1.77614 6.99999 1.5 6.99999C1.22386 6.99999 1 7.22385 1 7.49999V9.49999ZM11 8.99999C11.555 8.99999 12 8.55499 12 7.99999V2C12 1.445 11.555 0.999999 11 0.999999H5C4.45 0.999999 4 1.445 4 2V4L3 5L4 5.99999V7.99999C4 8.55499 4.45 8.99999 5 8.99999H11ZM9.99998 3.49998H5.99998V4.49998H9.99998V3.49998ZM8.99998 5.49998H5.99998V6.49998H8.99998V5.49998Z" fill="#9411AC"/>
                                </svg>
                                <span>Summarize</span>
                            </span>
                        </Tooltip>
                    </p>
                </div>

                <div className={classes.styleBlock}>
                    <p onClick={()=>{handleAskAiClickWithAction('custom')}} >
                        <Tooltip title="write your own prompt for AI" arrow placement="top">
                            <span>
                                <svg width="12" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.5 0V5.49999H2V9.99999L5.5 4H3.5L5.5 0H0.5Z" fill="#9411AC"/>
                                </svg>
                                <span>Free text</span>
                            </span>
                        </Tooltip>
                    </p>
                    <StyledTextField type='text' placeholder='Enter Text...' name='party' value={text} className={
                        emptyText ? classes.textField + ' ' + classes.empty : classes.textField
                    }
                         onChange={(e)=> {setText(e.target.value);}}
                         onKeyPress={(e) => {
                             if (e.key === 'Enter' && text && text.length > 3  ) {
                                 handleAskAiClickWithAction('custom')
                             }
                         }}
                    >
                    </StyledTextField>

                    {text && text.length > 3 ? <svg onClick={()=>{handleAskAiClickWithAction('custom')}} className={classes.inputCheck} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="13" height="13" rx="2" fill="#1174E5"/>
                        <path d="M10.625 4.20832L5.12502 9.70832L2.60419 7.18749L3.25044 6.54124L5.12502 8.41124L9.97877 3.56207L10.625 4.20832Z" fill="white"/>
                    </svg> : null }
                    {emptyText ? <svg className={classes.inputCheckError} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.375 2.625H4.125V1.875H3.375M3.75 6.75C2.09625 6.75 0.75 5.40375 0.75 3.75C0.75 2.09625 2.09625 0.75 3.75 0.75C5.40375 0.75 6.75 2.09625 6.75 3.75C6.75 5.40375 5.40375 6.75 3.75 6.75ZM3.75 0C3.25754 0 2.76991 0.0969966 2.31494 0.285452C1.85997 0.473907 1.44657 0.75013 1.09835 1.09835C0.395088 1.80161 0 2.75544 0 3.75C0 4.74456 0.395088 5.69839 1.09835 6.40165C1.44657 6.74987 1.85997 7.02609 2.31494 7.21455C2.76991 7.403 3.25754 7.5 3.75 7.5C4.74456 7.5 5.69839 7.10491 6.40165 6.40165C7.10491 5.69839 7.5 4.74456 7.5 3.75C7.5 3.25754 7.403 2.76991 7.21455 2.31494C7.02609 1.85997 6.74987 1.44657 6.40165 1.09835C6.05343 0.75013 5.64003 0.473907 5.18506 0.285452C4.73009 0.0969966 4.24246 0 3.75 0ZM3.375 5.625H4.125V3.375H3.375V5.625Z" fill="#FF7070"/>
                    </svg> : null}

                </div>

                {(isLoading) && <LinearProgress color="primary" className={classes.progress}/>}


                {
                    promptAiError && !isLoading
                        ?
                        <div className={classes.aiError}>
                            <Typography className={classes.titleAiError}>
                                <span style={{marginLeft: 'auto', order: '1'}}>AI Suggests!</span>
                                <svg style={{marginLeft: 'auto', marginRight: '10px', order: '2'}} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.34078 4.09266C9.42637 3.83888 9.47002 3.57317 9.47007 3.30571C9.47004 2.86314 9.35056 2.42856 9.12392 2.04664C8.6685 1.26448 7.8237 0.781573 6.9094 0.781573C6.72928 0.781576 6.54966 0.800346 6.37353 0.837572C6.13663 0.574218 5.84584 0.363404 5.52034 0.219031C5.19484 0.074659 4.84202 7.69704e-06 4.48514 0H4.46911L4.4631 3.48928e-05C3.35572 3.48928e-05 2.37367 0.705082 2.03325 1.74448C1.68087 1.81569 1.34797 1.96036 1.05684 2.16879C0.765717 2.37722 0.523075 2.64461 0.345161 2.95306C0.119209 3.33728 0.000138266 3.77357 0 4.21778C8.63507e-05 4.84207 0.23495 5.44412 0.659114 5.90734C0.573493 6.16111 0.529826 6.42683 0.529789 6.69429C0.529829 7.13686 0.649306 7.57144 0.87594 7.95336C1.14545 8.41636 1.55703 8.78293 2.05132 9.00023C2.54561 9.21752 3.09707 9.27431 3.62619 9.16239C3.86312 9.42575 4.15393 9.63656 4.47945 9.78094C4.80498 9.92532 5.15782 9.99998 5.51472 10H5.53074L5.53725 9.99997C6.64524 9.99997 7.62697 9.29488 7.96739 8.25454C8.31977 8.18331 8.65266 8.03863 8.94379 7.83019C9.23492 7.62176 9.47758 7.35437 9.65551 7.04593C9.88122 6.66205 10.0001 6.22612 10 5.78232C9.99992 5.15805 9.76494 4.55587 9.34078 4.09266ZM5.53138 9.34624H5.52876C5.08541 9.34609 4.65614 9.19263 4.31559 8.91253C4.33581 8.90178 4.35579 8.89061 4.37553 8.87901L6.39349 7.72891C6.44384 7.70062 6.48572 7.65969 6.51485 7.61027C6.54399 7.56084 6.55934 7.50469 6.55936 7.44752V4.63854L7.4123 5.12448C7.41678 5.12668 7.42064 5.12994 7.42353 5.13396C7.42643 5.13799 7.42827 5.14266 7.4289 5.14756V7.4722C7.42773 8.50573 6.57893 9.34414 5.53138 9.34624ZM1.4507 7.62658C1.28402 7.34221 1.1962 7.01952 1.19608 6.69101C1.19608 6.58387 1.20557 6.47644 1.22404 6.37087C1.23904 6.37974 1.26522 6.39552 1.28401 6.40617L3.30197 7.55627C3.35228 7.58525 3.40949 7.60051 3.46775 7.6005C3.52601 7.60049 3.58321 7.5852 3.63351 7.5562L6.09723 6.15257V7.12448L6.09726 7.12615C6.09726 7.13083 6.09616 7.13545 6.09404 7.13964C6.09192 7.14382 6.08885 7.14747 6.08505 7.15028L4.04508 8.31243C3.75644 8.47634 3.42926 8.56265 3.09622 8.56275C2.76283 8.5627 2.43531 8.47617 2.1465 8.31185C1.85769 8.14752 1.61774 7.91127 1.4507 7.62658ZM0.919815 3.27984C1.14145 2.89999 1.49141 2.60916 1.90845 2.45822C1.90845 2.47536 1.90746 2.50573 1.90746 2.52682V4.82706L1.90742 4.82895C1.90743 4.88606 1.92276 4.94216 1.95185 4.99154C1.98094 5.04092 2.02276 5.08182 2.07305 5.11009L4.53677 6.51352L3.68386 6.99946C3.67965 7.0022 3.67482 7.00386 3.66981 7.00431C3.66479 7.00477 3.65973 7.00398 3.65509 7.00204L1.61491 5.83892C1.3265 5.67406 1.08707 5.43731 0.920611 5.15239C0.754151 4.86747 0.666511 4.54438 0.666473 4.21551C0.666601 3.88715 0.753884 3.56447 0.919815 3.27984ZM7.92759 4.88889L5.46387 3.48529L6.31681 2.99953C6.32102 2.99679 6.32585 2.99512 6.33087 2.99467C6.33589 2.99422 6.34094 2.995 6.34558 2.99695L8.38572 4.15909C8.67437 4.32369 8.91406 4.56031 9.08072 4.8452C9.24738 5.1301 9.33515 5.45324 9.33523 5.78218C9.33523 6.56732 8.8387 7.26985 8.09212 7.54101V5.17199L8.09222 5.16934C8.09221 5.11244 8.07698 5.05654 8.04807 5.0073C8.01916 4.95806 7.9776 4.91722 7.92759 4.88889ZM8.77653 3.62819C8.75669 3.6162 8.73671 3.60444 8.71659 3.59293L6.69863 2.44279C6.64831 2.41386 6.59113 2.39861 6.5329 2.39859C6.47466 2.39861 6.41748 2.41386 6.36716 2.44279L3.90341 3.84642V2.87451L3.90338 2.87283C3.90338 2.86334 3.90794 2.8544 3.91562 2.84871L5.95559 1.68754C6.24414 1.5234 6.57135 1.43699 6.90442 1.43698C7.95331 1.43698 8.80391 2.27626 8.80391 3.31119C8.80386 3.41739 8.7947 3.52351 8.77653 3.62819ZM3.43968 5.36045L2.58656 4.87451C2.58209 4.87231 2.57823 4.86905 2.57534 4.86502C2.57244 4.861 2.5706 4.85633 2.56997 4.85143V2.52675C2.57043 1.49238 3.42104 0.653796 4.46947 0.653796C4.91351 0.653887 5.34351 0.807371 5.68484 1.08761C5.66948 1.09589 5.6427 1.11048 5.6249 1.12113L3.60694 2.27123C3.55659 2.2995 3.51472 2.34041 3.48559 2.38982C3.45646 2.43922 3.44111 2.49536 3.4411 2.55252V2.55437L3.43968 5.36045ZM3.90302 4.37478L5.00032 3.74944L6.09761 4.37436V5.62463L5.00032 6.24959L3.90302 5.62463V4.37478Z" fill="#FF5959"/>
                                </svg>
                            </Typography>
                            <div className={classes.aiErrorContent}>
                                <ErrorIcon fontSize='large' htmlColor='rgba(255, 89, 89, 0.15)' className={classes.aiErrorIcon}/>
                                {/*<span className={classes.aiErrorText}>Error - please try to refresh or rephrase your search</span>*/}
                                <span className={classes.aiErrorText}>{promptAiErrorText ? promptAiErrorText : 'Server Error'}</span>
                            </div>
                        </div>
                        :
                        promptAiResult && !isLoading ?
                        <>
                            <div className={classes.styleForBlockSuggest}>
                                <Typography className={classes.title}>
                                    <svg width="12" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.34078 4.09266C9.42637 3.83888 9.47002 3.57317 9.47007 3.30571C9.47004 2.86314 9.35056 2.42856 9.12392 2.04664C8.6685 1.26448 7.8237 0.781573 6.9094 0.781573C6.72928 0.781576 6.54966 0.800346 6.37353 0.837572C6.13663 0.574218 5.84584 0.363404 5.52034 0.219031C5.19484 0.074659 4.84202 7.69704e-06 4.48514 0H4.46911L4.4631 3.48928e-05C3.35572 3.48928e-05 2.37367 0.705082 2.03325 1.74448C1.68087 1.81569 1.34797 1.96036 1.05684 2.16879C0.765717 2.37722 0.523075 2.64461 0.345161 2.95306C0.119209 3.33728 0.000138266 3.77357 0 4.21778C8.63507e-05 4.84207 0.23495 5.44412 0.659114 5.90734C0.573493 6.16111 0.529826 6.42683 0.529789 6.69429C0.529829 7.13686 0.649306 7.57144 0.87594 7.95336C1.14545 8.41636 1.55703 8.78293 2.05132 9.00023C2.54561 9.21752 3.09707 9.27431 3.62619 9.16239C3.86312 9.42575 4.15393 9.63656 4.47945 9.78094C4.80498 9.92532 5.15782 9.99998 5.51472 10H5.53074L5.53725 9.99997C6.64524 9.99997 7.62697 9.29488 7.96739 8.25454C8.31977 8.18331 8.65266 8.03863 8.94379 7.83019C9.23492 7.62176 9.47758 7.35437 9.65551 7.04593C9.88122 6.66205 10.0001 6.22612 10 5.78232C9.99992 5.15805 9.76494 4.55587 9.34078 4.09266ZM5.53138 9.34624H5.52876C5.08541 9.34609 4.65614 9.19263 4.31559 8.91253C4.33581 8.90178 4.35579 8.89061 4.37553 8.87901L6.39349 7.72891C6.44384 7.70062 6.48572 7.65969 6.51485 7.61027C6.54399 7.56084 6.55934 7.50469 6.55936 7.44752V4.63854L7.4123 5.12448C7.41678 5.12668 7.42064 5.12994 7.42353 5.13396C7.42643 5.13799 7.42827 5.14266 7.4289 5.14756V7.4722C7.42773 8.50573 6.57893 9.34414 5.53138 9.34624ZM1.4507 7.62658C1.28402 7.34221 1.1962 7.01952 1.19608 6.69101C1.19608 6.58387 1.20557 6.47644 1.22404 6.37087C1.23904 6.37974 1.26522 6.39552 1.28401 6.40617L3.30197 7.55627C3.35228 7.58525 3.40949 7.60051 3.46775 7.6005C3.52601 7.60049 3.58321 7.5852 3.63351 7.5562L6.09723 6.15257V7.12448L6.09726 7.12615C6.09726 7.13083 6.09616 7.13545 6.09404 7.13964C6.09192 7.14382 6.08885 7.14747 6.08505 7.15028L4.04508 8.31243C3.75644 8.47634 3.42926 8.56265 3.09622 8.56275C2.76283 8.5627 2.43531 8.47617 2.1465 8.31185C1.85769 8.14752 1.61774 7.91127 1.4507 7.62658ZM0.919815 3.27984C1.14145 2.89999 1.49141 2.60916 1.90845 2.45822C1.90845 2.47536 1.90746 2.50573 1.90746 2.52682V4.82706L1.90742 4.82895C1.90743 4.88606 1.92276 4.94216 1.95185 4.99154C1.98094 5.04092 2.02276 5.08182 2.07305 5.11009L4.53677 6.51352L3.68386 6.99946C3.67965 7.0022 3.67482 7.00386 3.66981 7.00431C3.66479 7.00477 3.65973 7.00398 3.65509 7.00204L1.61491 5.83892C1.3265 5.67406 1.08707 5.43731 0.920611 5.15239C0.754151 4.86747 0.666511 4.54438 0.666473 4.21551C0.666601 3.88715 0.753884 3.56447 0.919815 3.27984ZM7.92759 4.88889L5.46387 3.48529L6.31681 2.99953C6.32102 2.99679 6.32585 2.99512 6.33087 2.99467C6.33589 2.99422 6.34094 2.995 6.34558 2.99695L8.38572 4.15909C8.67437 4.32369 8.91406 4.56031 9.08072 4.8452C9.24738 5.1301 9.33515 5.45324 9.33523 5.78218C9.33523 6.56732 8.8387 7.26985 8.09212 7.54101V5.17199L8.09222 5.16934C8.09221 5.11244 8.07698 5.05654 8.04807 5.0073C8.01916 4.95806 7.9776 4.91722 7.92759 4.88889ZM8.77653 3.62819C8.75669 3.6162 8.73671 3.60444 8.71659 3.59293L6.69863 2.44279C6.64831 2.41386 6.59113 2.39861 6.5329 2.39859C6.47466 2.39861 6.41748 2.41386 6.36716 2.44279L3.90341 3.84642V2.87451L3.90338 2.87283C3.90338 2.86334 3.90794 2.8544 3.91562 2.84871L5.95559 1.68754C6.24414 1.5234 6.57135 1.43699 6.90442 1.43698C7.95331 1.43698 8.80391 2.27626 8.80391 3.31119C8.80386 3.41739 8.7947 3.52351 8.77653 3.62819ZM3.43968 5.36045L2.58656 4.87451C2.58209 4.87231 2.57823 4.86905 2.57534 4.86502C2.57244 4.861 2.5706 4.85633 2.56997 4.85143V2.52675C2.57043 1.49238 3.42104 0.653796 4.46947 0.653796C4.91351 0.653887 5.34351 0.807371 5.68484 1.08761C5.66948 1.09589 5.6427 1.11048 5.6249 1.12113L3.60694 2.27123C3.55659 2.2995 3.51472 2.34041 3.48559 2.38982C3.45646 2.43922 3.44111 2.49536 3.4411 2.55252V2.55437L3.43968 5.36045ZM3.90302 4.37478L5.00032 3.74944L6.09761 4.37436V5.62463L5.00032 6.24959L3.90302 5.62463V4.37478Z" fill="#10A37F"/>
                                    </svg>
                                    <span style={{marginLeft: '8px'}}>AI suggests:</span>
                                </Typography>
                                <div style={{width: '80px', marginRight: '5px'}}>
                                    <div  style={{display: 'flex'}} >

                                        <Tooltip title="regenerate response" arrow placement="bottom">
                                            <StyledButton onClick={handleAskAiClick} className={classes.noBg}>
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.45958 9.23749C9.69792 8.86374 9.83333 8.41416 9.83333 7.93749C9.83333 6.58333 8.75 5.49999 7.39583 5.49999C6.04167 5.49999 4.95833 6.58333 4.95833 7.93749C4.95833 9.29166 6.04167 10.375 7.39583 10.375C7.86708 10.375 8.31125 10.2396 8.685 10.0067L10.375 11.6696L11.1279 10.9167L9.45958 9.23749ZM7.39583 9.29166C6.64833 9.29166 6.04167 8.68499 6.04167 7.93749C6.04167 7.18999 6.64833 6.58333 7.39583 6.58333C8.14333 6.58333 8.75 7.18999 8.75 7.93749C8.75 8.68499 8.14333 9.29166 7.39583 9.29166ZM4.19458 9.39999L0.625 6.62124L1.5025 5.93874L3.875 7.78583C3.875 7.83999 3.875 7.88874 3.875 7.93749C3.875 8.45749 3.99417 8.95583 4.19458 9.39999ZM1.50792 4.56291L0.625 3.87499L5.5 0.0833282L10.375 3.87499L9.48667 4.56291L9.10208 4.86083C8.59833 4.57916 8.01333 4.41666 7.39583 4.41666C5.92792 4.41666 4.66583 5.32666 4.14583 6.61041L1.50792 4.56291Z" fill="#1174E5"/>
                                                </svg>
                                            </StyledButton>
                                        </Tooltip>

                                        <Tooltip title="keep for future use" arrow placement="bottom">
                                            <StyledButton className={classes.noBg}>
                                                <svg width="12" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.66667 5.49999V1.16666H6.20833V0.0833282H0.791667V1.16666H1.33333V5.49999L0.25 6.58333V7.66666H3.06667V10.9167H3.93333V7.66666H6.75V6.58333L5.66667 5.49999Z" fill="#1174E5"/>
                                                </svg>
                                            </StyledButton>
                                        </Tooltip>

                                        <Tooltip title="copy text" arrow placement="bottom">
                                            <StyledButton onClick={handleClick} className={classes.noBg}>
                                                <svg width="12" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.29165 2.70834H3.33331C3.046 2.70834 2.77045 2.82248 2.56728 3.02564C2.36412 3.2288 2.24998 3.50435 2.24998 3.79167V11.375C2.24998 11.6623 2.36412 11.9379 2.56728 12.141C2.77045 12.3442 3.046 12.4583 3.33331 12.4583H9.29165C9.57897 12.4583 9.85452 12.3442 10.0577 12.141C10.2608 11.9379 10.375 11.6623 10.375 11.375V3.79167C10.375 3.50435 10.2608 3.2288 10.0577 3.02564C9.85452 2.82248 9.57897 2.70834 9.29165 2.70834ZM7.66665 0.541672H1.16665C0.879328 0.541672 0.603778 0.655808 0.400614 0.858973C0.19745 1.06214 0.083313 1.33769 0.083313 1.62501V9.20834H1.16665V1.62501H7.66665V0.541672Z" fill="#1174E5"/>
                                                </svg>
                                            </StyledButton>
                                        </Tooltip>





                                    </div>
                                </div>
                            </div>
                            <p className={classes.textAreaResult}>
                                {result}
                            </p>

                        </> : null

                }


            </div>
            <div style={{display: 'flex', height: '1px'}}></div>
        </div>
    );
}
